import React, { FC, useEffect, useRef } from 'react'

import cn from 'classnames'

import classes from './trust-pilot.module.scss'

interface TrustPilotProps {
  borderBottom?: boolean
  compact?: boolean
  dataTestId?: string
  theme?: string
  reviewTag?: string
  featureTrustPilot?: boolean
}

export const TrustPilot: FC<TrustPilotProps> = ({
  borderBottom,
  compact,
  dataTestId = 'trustpilot-widget',
  theme = 'dark',
  reviewTag = 'websitewidget',
  featureTrustPilot,
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.async = true
    s.src =
      'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    if (ref.current) {
      ref.current.appendChild(s)
    }

    return () => {
      if (window.Trustpilot) {
        delete window.Trustpilot
      }
    }
  }, [])

  return (
    <div ref={ref}>
      <section
        className={cn(
          classes.wrapper,
          compact && classes.compact,
          borderBottom && classes.withBorderBottom
        )}
        id="trust-pilot"
        data-testid="trustpilot-widget"
      >
        <div
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="53aa8912dec7e10d38f59f36"
          data-businessunit-id="59cecd980000ff0005ac6485"
          data-style-height="140px"
          data-style-width="100%"
          data-theme={theme}
          data-tags={reviewTag}
          data-stars={featureTrustPilot ? '4,5' : '5'}
          data-review-languages="en"
          data-font-family="Montserrat"
          data-testid={dataTestId}
          {...(featureTrustPilot && {
            'data-token': 'ce20ad14-7283-4518-a4e1-58f0d7790c7b',
          })}
        >
          <a
            href="https://www.trustpilot.com/review/smarty.co.uk"
            target="_blank"
            rel="noopener noreferrer"
          >
            Trustpilot
          </a>
        </div>
      </section>
    </div>
  )
}
